<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'cloudChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        cuozu:{
            type:String,
            default:function(){
                return '100px';
            }, 
        },
        jump:{
            type:String,
            default:function(){
                return '';
            }
        },
        dataArray: { 
            type: Array | Object
        }
    },
    mounted() {
        let that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        cloudOption:function(){
            let _this = this;
            let option = {
                tooltip: {
                    show: true
                },
                // toolbox: {
                //     feature: {
                //         saveAsImage: {
                //             title: '下载',
                //         }
                //     },
                //     right:_this.cuozu,
                // },
                series: [
                {
                    name: "",
                    type: "wordCloud",
                    size: ["100%", "100%"],
                    textRotation: [0, 45, 90, -45],
                    textPadding: 0,
                    sizeRange: [14, 40],
                    gridSize: 10,
                    autoSize: {
                        enable: true,
                        minSize: 14
                    },
                    textStyle: {
                        normal: {
                            color: function() {
                            return (
                                "rgb(" +
                                Math.round(Math.random() * 205) +
                                ", " +
                                Math.round(Math.random() * 205) +
                                ", " +
                                Math.round(Math.random() * 205) +
                                ")"
                            );
                            }
                        }
                    },
                    data: _this.dataArray
                }
                ]
            };
            return option;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.cloudOption());
            _this.chart.on('click', function (param) {
                let type = _this.jump;
                if(type != ''){//不为空需要跳转
                    _this.$parent.$refs.child.listJump(type,param.name);
                }
                
            });
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%;}
</style>


// WEBPACK FOOTER //
// src/components/echart/wordCloud.vue